import { css } from "./webComponents";

export const animations: string = css`
@keyframes glow {
    0% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); }
    50% { text-shadow: 0 0 15px rgba(255, 255, 255, 1); }
    100% { text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); }
}

@keyframes greenGlow {
    0% { text-shadow: 0 0 15px rgba(0, 255, 0, 0.9), 0 0 15px rgba(0, 255, 0, 0.9); }
    50% { text-shadow: 0 0 25px rgba(0, 255, 0, 1), 0 0 25px rgba(0, 255, 0, 0.9); }
    100% { text-shadow: 0 0 15px rgba(0, 255, 0, 0.9), 0 0 15px rgba(0, 255, 0, 0.9); }
}

@keyframes hover {
    0% { transform: scale(1.02); }
    50% { transform: scale(1.07); }
    100% { transform: scale(1.02); }
}

@keyframes hover2 {
    0% { transform: scale(1); }
    50% { transform: scale(1.02); }
    100% { transform: scale(1); }
}

@keyframes blink {
    0% { visibility: visible; }
    50% { visibility: hidden; }
    100% { visibility: visible; }
}
`;

export const pixelCornersCss: string = css`
    .pixel-corners,
    .pixel-corners--wrapper {
    clip-path: polygon(0px calc(100% - 9px),
        3px calc(100% - 9px),
        3px calc(100% - 6px),
        6px calc(100% - 3px),
        9px calc(100% - 3px),
        9px 100%,
        calc(100% - 9px) 100%,
        calc(100% - 9px) calc(100% - 3px),
        calc(100% - 6px) calc(100% - 3px),
        calc(100% - 3px) calc(100% - 6px),
        calc(100% - 3px) calc(100% - 9px),
        100% calc(100% - 9px),
        100% 9px,
        calc(100% - 3px) 9px,
        calc(100% - 3px) 6px,
        calc(100% - 6px) 3px,
        calc(100% - 9px) 3px,
        calc(100% - 9px) 0px,
        9px 0px,
        9px 3px,
        6px 3px,
        3px 6px,
        3px 9px,
        0px 9px);
    position: relative;
    }
    .pixel-corners {
    border: 6px solid transparent;
    }

    .pixel-corners--wrapper .pixel-corners {
    display: block;
    clip-path: polygon(6px 12px,
        9px 12px,
        9px 9px,
        12px 9px,
        12px 6px,
        calc(100% - 12px) 6px,
        calc(100% - 12px) 9px,
        calc(100% - 9px) 9px,
        calc(100% - 9px) 12px,
        calc(100% - 6px) 12px,
        calc(100% - 6px) calc(100% - 12px),
        calc(100% - 9px) calc(100% - 12px),
        calc(100% - 9px) calc(100% - 9px),
        calc(100% - 12px) calc(100% - 9px),
        calc(100% - 12px) calc(100% - 6px),
        12px calc(100% - 6px),
        12px calc(100% - 9px),
        9px calc(100% - 9px),
        9px calc(100% - 12px),
        6px calc(100% - 12px));
    }
    .pixel-corners::after,
    .pixel-corners--wrapper::after {
    content: "";
    position: absolute;
    clip-path: polygon(0px calc(100% - 9px),
        3px calc(100% - 9px),
        3px calc(100% - 6px),
        6px calc(100% - 3px),
        9px calc(100% - 3px),
        9px 100%,
        calc(100% - 9px) 100%,
        calc(100% - 9px) calc(100% - 3px),
        calc(100% - 6px) calc(100% - 3px),
        calc(100% - 3px) calc(100% - 6px),
        calc(100% - 3px) calc(100% - 9px),
        100% calc(100% - 9px),
        100% 9px,
        calc(100% - 3px) 9px,
        calc(100% - 3px) 6px,
        calc(100% - 6px) 3px,
        calc(100% - 9px) 3px,
        calc(100% - 9px) 0px,
        9px 0px,
        9px 3px,
        6px 3px,
        3px 6px,
        3px 9px,
        0px 9px,
        0px 50%,
        6px 50%,
        6px 12px,
        9px 12px,
        9px 9px,
        12px 9px,
        12px 6px,
        calc(100% - 12px) 6px,
        calc(100% - 12px) 9px,
        calc(100% - 9px) 9px,
        calc(100% - 9px) 12px,
        calc(100% - 6px) 12px,
        calc(100% - 6px) calc(100% - 12px),
        calc(100% - 9px) calc(100% - 12px),
        calc(100% - 9px) calc(100% - 9px),
        calc(100% - 12px) calc(100% - 9px),
        calc(100% - 12px) calc(100% - 6px),
        12px calc(100% - 6px),
        12px calc(100% - 9px),
        9px calc(100% - 9px),
        9px calc(100% - 12px),
        6px calc(100% - 12px),
        6px 50%,
        0px 50%);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background:rgb(255, 255, 255);
    display: block;
    pointer-events: none;
    }
    .pixel-corners::after {
    margin: -6px;
}
`;
